<template lang='pug'>
.publicArticles
  SectionTitle(:sectionText='staticData.partnerMain.title')
  Search(:staticData="staticData" @search="search" @sortByType="sortByType" :userType="userType" :sortType="sortConfig.defaultSortType" :sortConfig="sortConfig")
  table.tableTop10
    TableHead(@sortByType="sortByType")
    TableBody(:infos="infos")
  TableBodyNoArticle(v-if="(!infos || infos.length == 0)" text="查無資料，請嘗試其他關鍵字或篩選條件。" :isLoading="isLoading")
  Pagination(v-if="(infos && infos.length > 0)" :pageCount='totalPages' :currentPage='localParams.page + 1' @changePage='changePage')
</template>

<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import Search from '@/components/modules/search/search.vue'
import TableHead from '@/components/modules/table_partner/table_partner_head.vue'
import TableBody from '@/components/modules/table_partner/table_partner_body.vue'
import TableBodyNoArticle from '@/components/modules/table_list/table_body_no_article.vue'
import Pagination from '@/components/modules/pagination/pagination.vue'
import { getParams, changeStyle, getDate, getRouteByParam, initLocalParamByQueryStr } from '@/plugins/tool.js'

export default {
  props: {
    staticData: Object,
    params: Object
  },
  components: {
    SectionTitle,
    Search,
    TableHead,
    TableBody,
    TableBodyNoArticle,
    Pagination
  },
  data() {
    return {
      infos: null,
      localParams: this.params,
      totalPages: 0,
      isLoading: false,
      userType: localStorage.getItem(this.$store.state.storageKeys.identity),
      sortConfig: {
        "type": "partners",
        "defaultSortType": "updatedAt-1"
      }
    }
  },
  created() {
    this.localParams = initLocalParamByQueryStr(this.$route.query, this.localParams)
    this.getInfo()
  },
  methods: {
    async getInfo() {
      this.isLoading = true
      let route = this.$store.state.URLs.apiPartner + this.$store.state.routes.latestArticles
      route = getRouteByParam(this.localParams, route)
      this.$axios.get(route, {
        headers: {
          "X-Line-Biz-Session": localStorage.getItem(this.$store.state.storageKeys.token),
        }
      })
      .then(result => {
        this.isLoading = false
        this.totalPages = result.data.pageSize
        this.infos = Object.values(result.data.articlesWithPageNumber);
        this.infos.forEach(info => {
          let date = getDate(info.article.updatedAt)
          info.article.updatedAtStr = date.year + "/" + date.month + "/" + date.date
        })
      })
      .catch(() => {
        this.isLoading = false
      })

    },
    changePage(page) {
      this.localParams.page = page - 1
      this.$router.push({
        "path": this.$route.path,
        "query": {
          "type": this.type,
          "params": JSON.stringify(this.localParams)
        }
      })
    },
    sortByType(sortData) {
      changeStyle(sortData)
      this.localParams = getParams(this.localParams, sortData)
      this.getInfo()
    },
    search(keyword, start, end, govId, partnerId, categoryId, type) {
      this.localParams["page"] = 0
      this.params["page"] = 0
      this.localParams["keyword"] = keyword
      this.params["keyword"] = keyword
      this.localParams["type"] = type
      this.params["type"] = type
      if (govId != null) {
        this.localParams["govOptionId"] = govId
        this.params["govOptionId"] = govId
      }
      else {
        delete this.localParams.govOptionId
        delete this.params.govOptionId
      }
      if (start) {
        this.localParams["startDate"] = start.toISOString()
        this.params["startDate"] = start.toISOString()
      }
      else {
        delete this.localParams.startDate
        delete this.params.startDate
      }
      if (end) {
        this.localParams["endDate"] = end.toISOString()
        this.params["endDate"] = end.toISOString()
      }
      else {
        delete this.localParams.endDate
        delete this.params.endDate
      }
      if (categoryId) {
        this.localParams["categoryId"] = categoryId
        this.params["categoryId"] = categoryId
      }
      else {
        delete this.localParams.categoryId
        delete this.params.categoryId
      }
      if (partnerId) {
        this.localParams["partnerId"] = partnerId
        this.params["partnerId"] = partnerId
      }
      else {
        delete this.localParams.partnerId
        delete this.params.partnerId
      }
      this.getInfo()
    }
  }
}
</script>
